import $ from "jquery";
import Chart from 'chart.js';
import Seed from "DMS/Seed/All";
export function initHome() {
    var racAndIndicators = $('#racAndIndicatorsContainer');
    var chartContainer = $('#homeContainer');
    $(racAndIndicators).remove();
    $(chartContainer).remove();
    racAndIndicators = document.createElement('DIV');
    racAndIndicators.setAttribute('class', 'row');
    racAndIndicators.setAttribute('id', 'racAndIndicatorsContainer');
    chartContainer = document.createElement('DIV');
    chartContainer.setAttribute('class', 'row');
    chartContainer.setAttribute('id', 'homeContainer');
    $('#accueil_frame').append(racAndIndicators).append(chartContainer);
    Seed.Ajax.Post({
        url: 'homeController.php',
        async: true,
        json: true,
        success: (response) => {
            racAndIndicators = $('#racAndIndicatorsContainer');
            $(response['shortcuts']).appendTo(racAndIndicators);
            $(response['indicators']).appendTo(racAndIndicators);
            chartContainer = $('#homeContainer');
            $(response['charts']).appendTo(chartContainer);
        }
    });
}
export function chartAjaxCall(chartId, forHomeContainer) {
    var tempChartId = chartId.split("chart");
    var chartFinalId = tempChartId[1];
    var container = $('#' + chartId);
    var data = {
        myChartId: chartFinalId
    };
    if (forHomeContainer === 'true') {
        Seed.Ajax.Post({
            url: 'homeController.php',
            async: true,
            data: data,
            success: function (response) {
                $(response).appendTo(container);
            }
        });
    }
}
export function createChart(canvasId, graphType, graphName, graphLabels, curveTension, com0, colorSet, graphDataSet, graphDataLabelSet, hasToFillArea) {
    let ctx = document.getElementById(canvasId);
    let dataInfo = {};
    let dontDisplay = "";
    let toolTip = "";
    graphName = JSON.parse(graphName);
    graphLabels = JSON.parse(graphLabels);
    graphDataSet = JSON.parse(graphDataSet);
    if (graphType === 'pie' || graphType === 'doughnut') {
        dataInfo = generatePieOrDoughnut(graphDataSet, colorSet);
        dontDisplay = [{ display: false }];
        toolTip = { enabled: true };
    }
    else {
        dataInfo = generateStandard(graphLabels, graphDataSet, colorSet, curveTension, graphType, hasToFillArea);
        toolTip = { enabled: true, mode: 'x-axis' };
    }
    graphDataLabelSet = JSON.parse(graphDataLabelSet);
    for (let key in graphDataLabelSet) {
        graphDataLabelSet[key] = decodeURI(graphDataLabelSet[key]);
    }
    let startPoint = com0 === "1" ? [{ ticks: { beginAtZero: true } }] : "";
    new Chart(ctx, {
        type: graphType,
        data: {
            labels: graphDataLabelSet,
            datasets: dataInfo
        },
        options: {
            scales: {
                xAxes: dontDisplay,
                yAxes: startPoint
            },
            legend: {
                display: true,
                position: 'bottom'
            },
            title: {
                display: true,
                text: graphName,
                fontSize: 20,
                fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
            },
            tooltips: toolTip,
            showTooltips: true,
            animation: false
        }
    });
}
export function generatePieOrDoughnut(graphDataSet, colorSet) {
    let finalArray = [];
    const tempColorSet = colorSet.split('-');
    for (let counter = 0; counter < graphDataSet.length; counter++) {
        let myData = graphDataSet[counter].split(',');
        let finalColorSet = tempColorSet;
        let datasets = {
            data: myData,
            backgroundColor: finalColorSet
        };
        finalArray.push(datasets);
    }
    return finalArray;
}
export function generateStandard(graphLabels, graphDataSet, colorSet, curveTension, graphType, hasToFillArea) {
    let finalArray = [];
    for (let counter = 0; counter < graphDataSet.length; counter++) {
        let myLabel = graphLabels[counter].split(',');
        let myData = graphDataSet[counter].split(',');
        let tempColorSet = colorSet.split('-');
        let finalColorSet;
        if (graphType !== 'bar') {
            finalColorSet = tempColorSet[counter];
        }
        else if (graphType === 'bar') {
            for (let j = 0; j < myData.length; j++) {
                if (typeof tempColorSet[counter] === 'string') {
                    finalColorSet = tempColorSet[counter];
                }
            }
        }
        let myBackgroundColor = [];
        myBackgroundColor = finalColorSet;
        if (hasToFillArea === "1") {
            hasToFillArea = true;
        }
        else {
            hasToFillArea = false;
        }
        let datasets = {
            label: myLabel,
            data: myData,
            backgroundColor: myBackgroundColor,
            lineTension: curveTension,
            fill: hasToFillArea,
            borderWidth: 1
        };
        finalArray.push(datasets);
    }
    return finalArray;
}
export function stringToArray(myString) {
    return myString.split(',');
}
export function changeAlink(chartId, toDownload) {
    if (window.foo === undefined) {
        if (toDownload) {
            var realChartId = chartId.split('-');
            var context = document.getElementById(realChartId[1]).toDataURL();
            var newContext = context.replace("image/png", "image/octet-stream");
            $('#' + chartId).children('a').prop('href', newContext);
        }
        window.foo = 'changeAlink';
        var aId = '';
        if (toDownload) {
            aId = 'link-' + realChartId[1];
            $('#' + chartId).children('a').css('visibility', 'visible');
            document.getElementById(aId).click();
            $('#' + chartId).children('a').css('visibility', 'hidden');
        }
        else {
            var aLink = document.getElementById(chartId).children;
            aLink[1].style.visibility = 'visible';
            aLink[1].click();
            aLink[1].style.visibility = 'hidden';
        }
        window.foo = undefined;
    }
}
export function JSONToCSV(JSONData, reportTitle) {
    //If JSONData is not an object then JSON.parse will parse the JSON string into an Object
    var arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    reportTitle = JSON.parse(reportTitle);
    CSV += reportTitle + '\r\n\n';
    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
        var row = "";
        //2nd loop will extract each column and convert it in string separated by semi-column
        for (var index in arrData[i]) {
            row += '"' + arrData[i][index] + '";';
        }
        row.slice(0, row.length - 1);
        //add a line break after each row
        CSV += row + '\r\n';
    }
    //Generate a file name
    var fileName = "graphique_";
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += reportTitle.replace(/ /g, "_");
    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
    //this trick will generate a temp <a /> tag
    var linkContainer = document.getElementById(reportTitle);
    var link = document.createElement('a');
    link.href = uri;
    link.target = '_blank';
    link.download = fileName + '_' + new Date() + ".csv";
    //this part will append the anchor tag and remove it after automatic click
    linkContainer.appendChild(link);
}
//# sourceMappingURL=homeController.js.map